import { useEffect, useState } from 'react';
import { parseHtmlElementFromHtml } from '../utils/htmlReactParserWrapper';
import styles from './style.module.scss';
import { constructDigitalData, fireAnalyticsEvent } from '../analytics/analytics';
import { FORD_PRO_ACCOUNT_ONCLICKS, PAGE_NAME, REFERRAL_EXIT, REFERRAL_EXIT_ACTION, REFERRAL_EXIT_TOOL } from '../analytics/analyticsConstants';
import { useUniversalContext } from '@cxc/react-universal-components';
import { AnalyticsConstants, LocalesConstants } from '../utils/constants';

const InfoTableColumnContent = (props : {aemColumnTextContent?: string}) => {
    const [anchorHtmlElement, setAnchorHtmlElement] = useState<HTMLElement | null>(null);
    const [textBeforeAnchorTag, setTextBeforeAnchorTag] = useState<string | undefined>(undefined);
    const [textAfterAnchorTag, setTextAfterAnchorTag] = useState<string | undefined>(undefined);
    const {isLoggedIn, subscribeScopedValue, language} = useUniversalContext();
    const cookiePreferences = subscribeScopedValue(
        AnalyticsConstants.FPG_COOKIES,
        AnalyticsConstants.COOKIE_PREFERENCES,
    );

    useEffect(() => {
        if(props.aemColumnTextContent !== undefined || props.aemColumnTextContent !== '') {
            setTextBeforeAnchorTag(props.aemColumnTextContent?.split('<p>')[1].split('<u>')[0]);
            setTextAfterAnchorTag(props.aemColumnTextContent?.split('</u>')[1].split('</p>')[0]);
            setAnchorHtmlElement(parseHtmlElementFromHtml(props.aemColumnTextContent || '', 'a'));
        }
    }, [props.aemColumnTextContent]);

    const handlerAnchorClick = () => {
        if(language !== LocalesConstants.USLocale) {
            const digitalData = constructDigitalData(REFERRAL_EXIT_ACTION, PAGE_NAME, REFERRAL_EXIT, REFERRAL_EXIT_TOOL, '', FORD_PRO_ACCOUNT_ONCLICKS, isLoggedIn, cookiePreferences);
            fireAnalyticsEvent(digitalData.digitalData, digitalData.directCallName);
        }
    };

    return (
        <>
            {
                (props.aemColumnTextContent == undefined || props.aemColumnTextContent == '') ? 
                <p className={styles.paddingNoDataInfoTableColumn}></p> : 
                <p>
                    {textBeforeAnchorTag} 
                    <u>
                        <a href={anchorHtmlElement?.getAttribute('href') || ''} target="_blank" onClick={handlerAnchorClick}>
                            {anchorHtmlElement?.innerText}
                        </a>
                    </u>
                    {textAfterAnchorTag}
                </p>
            }
        </>
    );
};

export default InfoTableColumnContent;